import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../../axios";
import CoverFabricForm from "./CoverFabricForm";

export default function CoverFabricEditPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", image: "" });
    const [image, setImage] = useState(null);

    useEffect(() => {
        axios.get(`/admin/cover-fabrics/${id}`).then(res => {
            setForm(res.data);
        });
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("name", form.name);
        if (image) data.append("image", image);

        await axios.post(`/admin/cover-fabrics/${id}?_method=PUT`, data);
        navigate("/admin/cover-fabrics");
    };

    return (
        <CoverFabricForm
            form={form}
            setForm={setForm}
            image={image}
            setImage={setImage}
            onSubmit={handleSubmit}
            title="Edit Cover Fabric"
            buttonLabel="Update"
        />
    );
}
